/* eslint-disable no-alert, no-console */
import { AxiosError } from "axios";
import { SiteApi } from "../utils/api/siteApi";
import {
  ISearchResultResponse,
  ISearchRequest,
  IAutocompleteResponse,
  ISearchResultClickRequest,
  ISearchContentResponse,
} from "./searchApi.types";

const BaseUrl = `${
  (window as any).currentEnvironment.REACT_APP_API_OPTIMIZELY_URL
}`;

export const getSearchResults = async (request: ISearchRequest) => {
  try {
    return await SiteApi.Post<ISearchResultResponse>(
      `${BaseUrl}/api/v1/search/results/`,
      request
    );
  } catch (error) {
    console.error("error: ", error);
    return (error as AxiosError).response;
  }
};

export const getAutocompleteResults = async (
  searchTerm: string,
  size: number = 5
) => {
  try {
    return await SiteApi.Get<IAutocompleteResponse>(
      `${BaseUrl}/api/v1/search/autocomplete/${searchTerm}/${size}`
    );
  } catch (error) {
    console.error("error: ", error);
    return (error as AxiosError).response;
  }
};

export const postSearchResultClick = async (
  request: ISearchResultClickRequest
) => {
  try {
    return await SiteApi.Post<boolean>(
      `${BaseUrl}/api/v1/search/trackClick/`,
      request
    );
  } catch (error) {
    console.error("error: ", error);
    return (error as AxiosError).response;
  }
};

export const getSearchContent = async (language: string) => {
  try {
    return await SiteApi.Get<ISearchContentResponse>(
      `${BaseUrl}/api/v1/search/content/?language=${language}`
    );
  } catch (error) {
    console.error("error: ", error);
    return (error as AxiosError).response;
  }
};

export default {};
